// document.addEventListener("DOMContentLoaded", function () {
//   var sections = document.querySelectorAll(".custom_featured_product");

//   sections.forEach(function (section) {
//     var uniqueId = section.getAttribute("id");

//     // Thumb swiper
//     var thumbSwiper = new Swiper(`#${uniqueId} .thumbSwiper`, {
//       slidesPerView: 5,
//       spaceBetween: 24,
//       watchSlidesProgress: true,

//       navigation: {
//         nextEl: `#${uniqueId} .thumbSwiper .swiper-button-next`,
//         prevEl: `#${uniqueId} .thumbSwiper .swiper-button-prev`,
//       },

//       breakpoints: {
//         0: {
//           slidesPerView: 4,
//           spaceBetween: 12,
//         },
//         481: {
//           direction: "horizontal",
//         },
//         769: {
//           direction: "horizontal",
//         }
//       }
//     });

//     // Featured swiper
//     var featuredSwiper = new Swiper(`#${uniqueId} .featuredSwiper`, {
//       slidesPerView: 1,
//       spaceBetween: 1,

//       navigation: {
//         nextEl: `#${uniqueId} .featuredSwiper .swiper-button-next`,
//         prevEl: `#${uniqueId} .featuredSwiper .swiper-button-prev`,
//       },

//       thumbs: {
//         swiper: thumbSwiper,
//       },
//     });

//   });
// });
document.addEventListener("DOMContentLoaded", function () {
  var sections = document.querySelectorAll(".custom_featured_product");

  sections.forEach(function (section) {
    var uniqueId = section.getAttribute("id");

    // ======================
    // Thumb swiper
    // ======================
    var thumbSwiper = new Swiper(`#${uniqueId} .thumbSwiper`, {
      slidesPerView: 5,
      spaceBetween: 24,
      watchSlidesProgress: true,

      navigation: {
        nextEl: `#${uniqueId} .thumbSwiper .swiper-button-next`,
        prevEl: `#${uniqueId} .thumbSwiper .swiper-button-prev`,
      },

      breakpoints: {
        0: {
          slidesPerView: 4,
          spaceBetween: 12,
        },
        481: {
          direction: "horizontal",
        },
        769: {
          direction: "horizontal",
        }
      }
    });

    // ======================
    // Featured swiper
    // ======================
    var featuredSwiper = new Swiper(`#${uniqueId} .featuredSwiper`, {
      slidesPerView: 1,
      spaceBetween: 1,

      navigation: {
        nextEl: `#${uniqueId} .featuredSwiper .swiper-button-next`,
        prevEl: `#${uniqueId} .featuredSwiper .swiper-button-prev`,
      },

      thumbs: {
        swiper: thumbSwiper,
      },
    });

    // ==================================================
    // ✅ VARIANT CHANGE → IMAGE CHANGE (ADD THIS PART)
    // ==================================================
    var variantSelects = section.querySelector("variant-selects");
    if (!variantSelects) return;

    var variantsJson = variantSelects.querySelector(
      'script[type="application/json"]'
    );
    if (!variantsJson) return;

    var variants = JSON.parse(variantsJson.textContent);

    variantSelects.addEventListener("change", function () {
      var checkedInput = variantSelects.querySelector(
        'input[type="radio"]:checked'
      );
      if (!checkedInput) return;

      var selectedValue = checkedInput.value;

      // match variant
      var matchedVariant = variants.find(function (variant) {
        return variant.option1 === selectedValue;
      });

      if (!matchedVariant || !matchedVariant.featured_image) return;

      var variantImage = matchedVariant.featured_image.src.replace(/^\/\//, "");

      // find slide index
      var slides = featuredSwiper.slides;
      var targetIndex = 0;

      slides.forEach(function (slide, index) {
        var img = slide.querySelector("img");
        if (!img) return;

        var slideSrc = img.getAttribute("src")?.replace(/^\/\//, "");
        if (slideSrc === variantImage) {
          targetIndex = index;
        }
      });

      // move swipers
      featuredSwiper.slideTo(targetIndex);
      thumbSwiper.slideTo(targetIndex);
    });
  });
});


  var swiper = new Swiper(".upsell_product_wrapper .mySwiper", {
    slidesPerView: 1,
    spaceBetween: 10,
      autoHeight: true,
      loop: false, // Enable loop mode
    navigation: {
      nextEl: ".upsell_product_wrapper .swiper-button-next",
      prevEl: ".upsell_product_wrapper .swiper-button-prev",
    },
    pagination: {
      el: ".upsell_product_wrapper .swiper-pagination",
      clickable: true,
    },
 
  });














  // Upsell Js


//   $(document).ready(function() {

//   // Function to update cart drawer (optional)
//   function updateCartDrawer() {
   
// $('.cart-drawer').load(location.href + ' .cart-drawer > *');
// $('.product-cart-item').load(location.href + ' .product-cart-item > *');

//   }

//   // First, check cart and set checkbox state
//   $.getJSON('/cart.js', function(cart) {
//     $('.product-card input[type="checkbox"]').each(function() {
//       var $checkbox = $(this);
//       var productId = $checkbox.attr('product_id');

//       // If product is in cart, check the checkbox
//       var itemInCart = cart.items.find(i => i.id == productId);
//       $checkbox.prop('checked', !!itemInCart);
//     });
//   });

//   // Listen to checkbox changes
//   $('.product-card input[type="checkbox"]').change(function() {
//     var $checkbox = $(this);
//     var productId = $checkbox.attr('product_id');

//     if ($checkbox.is(':checked')) {
//       // Add product to cart
//       $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: {
//           id: productId,
//           quantity: 1
//         },
//         dataType: 'json',
//         success: function(response) {
//           console.log('Product added to cart:', response);
//             updateCartDrawer();
//             $('body').addClass('open-cc');
//                 $('body').addClass('open-cart');
// $('.cart-drawer').addClass('active');
// $('.cart-drawer--recommendations--container').addClass('active');
          
            
//         },
//         error: function(err) {
//           console.error('Error adding product:', err);
//           $checkbox.prop('checked', false); // revert if error
//         }
//       });
//     } else {
//       // Remove product from cart
//       $.ajax({
//         type: 'POST',
//         url: '/cart/change.js',
//         data: {
//           id: productId,
//           quantity: 0
//         },
//         dataType: 'json',
//         success: function(response) {
//           console.log('Product removed from cart:', response);
//           updateCartDrawer();
//         },
//         error: function(err) {
//           console.error('Error removing product:', err);
//           $checkbox.prop('checked', true); // revert if error
//         }
//       });
//     }
//   });

// });

$(document).ready(function() {


  // Function to update cart drawer
  function updateCartDrawer() {
    $('.cart-drawer').load(location.href + ' .cart-drawer > *', function() {
      console.log('Cart drawer refreshed');
      
      // Re-initialize any event listeners after reload
      initCartEvents();
    });
    $('.product-cart-item').load(location.href + ' .product-cart-item > *');
  }


  // Initialize cart event listeners
  function initCartEvents() {
    // ✅ FIXED: Quantity selector plus/minus buttons now prevent double-firing
    $('.quantity .plus').off('click').on('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation(); // Prevents event from bubbling
      
      var $qty = $(this).siblings('input.qty');
      var currentVal = parseInt($qty.val());
      var maxVal = parseInt($qty.attr('max'));
      
      if (currentVal < maxVal) {
        // Update the value without triggering change event
        var newVal = currentVal + 1;
        $qty.val(newVal);
        
        // Manually update cart (bypasses the change listener)
        updateCartQuantity($qty);
      }
    });

    $('.quantity .minus').off('click').on('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation(); // Prevents event from bubbling
      
      var $qty = $(this).siblings('input.qty');
      var currentVal = parseInt($qty.val());
      var minVal = parseInt($qty.attr('min'));
      
      if (currentVal > minVal) {
        // Update the value without triggering change event
        var newVal = currentVal - 1;
        $qty.val(newVal);
        
        // Manually update cart (bypasses the change listener)
        updateCartQuantity($qty);
      }
    });

    // Quantity input direct change (for manual typing)
    $('.quantity input.qty').off('change').on('change', function() {
      updateCartQuantity($(this));
    });

    // Remove item button
    $('a.remove').off('click').on('click', function(e) {
      e.preventDefault();
      var $link = $(this);
      var lineIndex = $link.data('index');
      
      removeFromCart(lineIndex);
    });
  }

  // Update cart item quantity
  function updateCartQuantity($input) {
    var lineIndex = $input.data('index');
    var quantity = parseInt($input.val());
    var variantId = $input.closest('.quantity').data('id').split(':')[0];

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        line: lineIndex,
        quantity: quantity
      },
      dataType: 'json',
      success: function(response) {
        console.log('Cart updated:', response);
        updateCartDrawer();
        
        // Update cart count
        updateCartCount(response.item_count);
      },
      error: function(err) {
        console.error('Error updating cart:', err);
      }
    });
  }

  // Remove item from cart
  function removeFromCart(lineIndex) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        line: lineIndex,
        quantity: 0
      },
      dataType: 'json',
      success: function(response) {
        console.log('Item removed from cart:', response);
        updateCartDrawer();
        
        // Update cart count
        updateCartCount(response.item_count);
        
        // Update checkbox if exists
        var $cartItem = $('#CartDrawerItem-' + lineIndex);
        var productLink = $cartItem.find('.cart-product-link').attr('href');
        if (productLink) {
          var variantId = productLink.match(/variant=(\d+)/);
          if (variantId) {
            $('.product-card input[product_id="' + variantId[1] + '"]').prop('checked', false);
          }
        }
      },
      error: function(err) {
        console.error('Error removing item:', err);
      }
    });
  }

  // Update cart count in header
  function updateCartCount(count) {
    $('.cart-count, [data-cart-count]').text(count);
    if (count > 0) {
      $('.cart-count, [data-cart-count]').show();
    } else {
      $('.cart-count, [data-cart-count]').hide();
    }
  }

  // First, check cart and set checkbox state
  $.getJSON('/cart.js', function(cart) {
    $('.product-card input[type="checkbox"]').each(function() {
      var $checkbox = $(this);
      var productId = $checkbox.attr('product_id');

      // If product is in cart, check the checkbox
      var itemInCart = cart.items.find(i => i.id == productId);
      $checkbox.prop('checked', !!itemInCart);
    });
    
    // Update cart count
    updateCartCount(cart.item_count);
  });

  // Listen to checkbox changes
  // $('.product-card input[type="checkbox"]').on('change', function() {
  //   var $checkbox = $(this);
  //   var productId = $checkbox.attr('product_id');

  //   if ($checkbox.is(':checked')) {
  //     // Add product to cart
  //     $.ajax({
  //       type: 'POST',
  //       url: '/cart/add.js',
  //       data: {
  //         id: productId,
  //         quantity: 1
  //       },
  //       dataType: 'json',
  //       success: function(response) {
  //         console.log('Product added to cart:', response);
  //         updateCartDrawer();
          
  //         // Open cart drawer
  //         $('body').addClass('open-cc');
  //         $('body').addClass('open-cart');
  //         $('.cart-drawer').addClass('active');
  //         $('.cart-drawer--recommendations--container').addClass('active');
          
  //         // Update cart count
  //         $.getJSON('/cart.js', function(cart) {
  //           updateCartCount(cart.item_count);
  //         });
  //       },
  //       error: function(err) {
  //         console.error('Error adding product:', err);
  //         $checkbox.prop('checked', false); // revert if error
  //       }
  //     });
  //   } else {
  //     // Remove product from cart
  //     $.ajax({
  //       type: 'POST',
  //       url: '/cart/change.js',
  //       data: {
  //         id: productId,
  //         quantity: 0
  //       },
  //       dataType: 'json',
  //       success: function(response) {
  //         console.log('Product removed from cart:', response);
  //         updateCartDrawer();
          
  //         // Update cart count
  //         updateCartCount(response.item_count);
  //       },
  //       error: function(err) {
  //         console.error('Error removing product:', err);
  //         $checkbox.prop('checked', true); // revert if error
  //       }
  //     });
  //   }
  // });



$('.product-card input[type="checkbox"]').on('change', function() {
    var $checkbox = $(this);
    var productId = $checkbox.attr('product_id');
$('.inpuit_wrapper').remove();
    if ($checkbox.is(':checked')) {
    
$('product-form.product-form form[action="/cart/add"]').append(`
  <div class="inpuit_wrapper">
    <input type="hidden" name="items[1][id]" value="${productId}">
    <input type="hidden" name="items[1][quantity]" value="1">
  </div>
`);

    } else {
$('.inpuit_wrapper').remove();
    }
  });

  // Close cart drawer
  $('.side-panel-close, side-panel-close').on('click', function() {
    $('body').removeClass('open-cc open-cart');
    $('.cart-drawer').removeClass('active');
  });

  // Initialize cart events on page load
  initCartEvents();

  // Listen for cart updates from other sources
  $(document).on('cart:updated', function() {
    updateCartDrawer();
  });

});




document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.mobile-credibility-slider');

  if (slider) {
    new Swiper(slider, {
      slidesPerView: 1,
        spaceBetween: 0, 
      loop: true,
      autoplay: {
        delay: 5000, // 5 seconds
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      },
      speed: 400
    });
  }
});



document.addEventListener("DOMContentLoaded", function () {

  if (!document.body.classList.contains('template-collection')) return;

  const categorySection = document.querySelector('.category_selector');
  const activeTab = document.querySelector('.category_selector .tab.active');

  if (categorySection && activeTab) {

    setTimeout(() => {
      categorySection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 100);
  }
});

  document.addEventListener('DOMContentLoaded', function () {
    const tabContainers = document.querySelectorAll('.wrap-product-usp');

    tabContainers.forEach(container => {
      const tabs = container.querySelectorAll('.product-usp-tab');
      const groups = container.querySelectorAll('.product-usp-group');

      function activateTab(tab) {
        const target = tab.dataset.tab;

        tabs.forEach(t => t.classList.remove('active'));
        groups.forEach(g => g.classList.remove('active'));

        tab.classList.add('active');

        const activeGroup = container.querySelector(
          '.product-usp-group[data-content="' + target + '"]'
        );

        if (activeGroup) {
          activeGroup.classList.add('active');
        }
      }

      const initialTab = container.querySelector('.product-usp-tab.active') || tabs[0];
      if (initialTab) activateTab(initialTab);

      tabs.forEach(tab => {
        tab.addEventListener('click', function () {
          activateTab(this);
        });
      });
    });
  });


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-description-wrap').forEach(wrapper => {
    const content = wrapper.querySelector('.js-readmore');
    const button = wrapper.querySelector('.read-more-toggle');

    if (content.scrollHeight <= content.clientHeight + 1) {
      button.style.display = 'none';
      return;
    }

    button.addEventListener('click', function () {
      const expanded = content.classList.toggle('expanded');

      button.textContent = expanded ? 'Read less' : 'Read more';
      button.setAttribute('aria-expanded', expanded);
    });
  });
});


document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.custom_ugc_slider').forEach(slider => {
    const swiperEl = slider.querySelector('.swiper_ugc');

    if (!swiperEl) return;

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1.2,
      spaceBetween: 16,
      loop: false,

      navigation: {
        nextEl: slider.querySelector('.ugc-next'),
        prevEl: slider.querySelector('.ugc-prev'),
      },

      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 24
        }
      },

      on: {
        slideChange: () => pauseAllVideos(slider)
      }
    });

    /* PLAY / PAUSE TOGGLE */
    slider.querySelectorAll('[data-play-btn]').forEach(btn => {
      btn.addEventListener('click', () => {
        const wrap = btn.closest('[data-video-wrap]');
        const video = wrap.querySelector('video');

        if (!video) return;

        const isPlaying = wrap.classList.contains('is-playing');

        // Stop all other videos
        pauseAllVideos(slider);

        if (!isPlaying) {
          video.muted = false;
          video.controls = true;
          video.play();

          wrap.classList.add('is-playing');
        }
      });
    });

    function pauseAllVideos(context) {
      context.querySelectorAll('[data-video-wrap]').forEach(wrap => {
        const video = wrap.querySelector('video');
        if (!video) return;

        video.pause();
        video.muted = true;
        video.controls = false;

        wrap.classList.remove('is-playing');
      });
    }
  });

});


// produt recommendations - upsell products
(() => {

  /* -----------------------------------------------------
      1️⃣  FORCE OVERRIDE SHOPIFY'S COMPONENT
  ----------------------------------------------------- */
  if (customElements.get("product-recommendations")) {
    customElements.define(
      "product-recommendations",
      class extends HTMLElement {},
      { override: true }
    );
  }

  /* -----------------------------------------------------
      2️⃣  OUR REPLACEMENT CLASS WITH .refresh()
  ----------------------------------------------------- */
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.loadWithObserver();
    }

    /* PUBLIC METHOD — usable in console */
    refresh() {
      console.log("🔄 Manual refresh triggered");
      this.loadRecommendations();
    }

    /* -----------------------------------------------------
        3️⃣ LOAD WHEN FIRST VISIBLE
    ----------------------------------------------------- */
    loadWithObserver() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations();
      };

      new IntersectionObserver(handleIntersection).observe(this);
    }

    /* -----------------------------------------------------
        4️⃣ BULLET-PROOF RECOMMENDATION LOADER
        Handles 1 item, 0 items, wrapper changes, raw HTML.
    ----------------------------------------------------- */
    loadRecommendations() {
      const sectionId = this.dataset.sectionId;
      const productId = this.dataset.productId;
      const intent = this.dataset.intent;

      fetch(`/recommendations/products?section_id=${sectionId}&product_id=${productId}&intent=${intent}`)
        .then(res => res.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, "text/html");

          // TRY ALL POSSIBLE SHOPIFY CONTAINERS
          let newContent =
            doc.querySelector("product-recommendations") ||
            doc.querySelector(".product-recommendations") ||
            doc.querySelector(".complementary-products");

          // FALLBACK: Shopify sometimes returns raw HTML
          if (newContent) {
            this.innerHTML = newContent.innerHTML;
          } else {
            this.innerHTML = html; // raw fallback
          }

          console.log("✅ Product recommendations refreshed (stable)");
        })
        .catch(err => console.error("❌ Recommendation load error:", err));
    }
  }

  /* -----------------------------------------------------
      5️⃣  REGISTER OUR CUSTOM ELEMENT
  ----------------------------------------------------- */
  customElements.define("product-recommendations", ProductRecommendations, {
    override: true
  });

})();




(function () {

  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;

    e.preventDefault();

    const btn = form.querySelector('button[type="submit"]');
    const idInput = form.querySelector('input[name="id"]');

    if (!idInput) {
      console.error('Variant ID not found');
      return;
    }

    const variantId = idInput.value;

    btn.classList.add('loading');
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(res => {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    })
    .then(() => {
      // Refresh Horizon cart drawer section
      return fetch('/cart?section_id=cart-drawer');
    })
    .then(res => res.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newDrawer = doc.querySelector('#Cart-Drawer');
      const currentDrawer = document.querySelector('#Cart-Drawer');

      if (!newDrawer || !currentDrawer) {
        console.warn('Cart drawer not found');
        return;
      }

      currentDrawer.innerHTML = newDrawer.innerHTML;
      currentDrawer.classList.add('active');

      document.body.classList.add('open-cart', 'open-cc');

      // 🔔 Tell Horizon & your upsells that cart changed
      document.dispatchEvent(new CustomEvent('cart:open'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    })
    .catch(err => {
      console.error('Add to cart error:', err);
    })
    .finally(() => {
      btn.classList.remove('loading');
      btn.disabled = false;
    });

  });

})();


// for Mobile submenu
$(document).ready(function(){

  $('.mobile-secondry-menu-li > a').on('click', function(e){

    var parentLi = $(this).closest('.mobile-secondry-menu-li');
    var index = parentLi.index() + 1;

    var submenu = $('.mobile_lv2_mneu .submenu-panel[data-menu="'+index+'"]');

    if(submenu.length){
      e.preventDefault();

      // hide other submenus
      $('.submenu-panel').removeClass('active');

      // show matching submenu
      submenu.addClass('active');

      // slide level 2 container
      $('.mobile_lv2_mneu').addClass('active');
    }

  });


  $('.menu-back').on('click', function(){

    $('.mobile_lv2_mneu').removeClass('active');
    $('.submenu-panel').removeClass('active');

  });

});